import 'vuetify/styles';

import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';

import { customMdiIcons } from './mdi-icons'; 

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      ...customMdiIcons, 
    },
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'capitalTheme',
    themes: {
      capitalTheme: {
        dark: false,
        colors: {
          primary: '#387ED1',      // action blue  
          secondary: '#64748B',    // muted slate
          tertiary: '#F59E0B',         // Attention/highlight amber
          accent: '#10B981',       // profit/success green
          surface: '#FFFFFF',      // cards, drawers, bars 
          'surface-variant': '#F8FAFC',
          background: '#F5F7FA',   // app background
          'on-primary': '#FFFFFF',
          'on-secondary': '#FFFFFF',
          'on-tertiary': '#FFFFFF',
          'on-surface': '#1F2937', 
          'on-surface-variant': '#6B7280',
          'on-background': '#1E293B',
          error: '#EF4444',
          warning: '#F59E0B',
          success: '#10B981',
          info: '#3B82F6',       
        },
      },  
      edtechTheme: {
        dark: false,
        colors: {
          primary: '#387ED1',      // action blue 
          secondary: '#64748B',    // muted slate
          tertiary: '#F59E0B',         // Attention/highlight amber
          accent: '#10B981',       // profit/success green
          surface: '#FFFFFF',      // cards, drawers, bars 
          'surface-variant': '#F8FAFC',
          background: '#F5F7FA',   // app background
          'on-primary': '#FFFFFF',
          'on-secondary': '#FFFFFF',
          'on-tertiary': '#FFFFFF',
          'on-surface': '#1F2937', 
          'on-surface-variant': '#6B7280',
          'on-background': '#1E293B',
          error: '#EF4444',
          warning: '#F59E0B',
          success: '#10B981',
          info: '#3B82F6',       
        },
      },

      artauctionTheme: {
        dark: false,
        colors: {
          primary: '#387ED1',      // action blue 
          secondary: '#64748B',    // muted slate
          tertiary: '#F59E0B',         // Attention/highlight amber
          accent: '#10B981',       // profit/success green
          surface: '#FFFFFF',      // cards, drawers, bars 
          'surface-variant': '#F8FAFC',
          background: '#F5F7FA',   // app background
          'on-primary': '#FFFFFF',
          'on-secondary': '#FFFFFF',
          'on-tertiary': '#FFFFFF',
          'on-surface': '#1F2937', 
          'on-surface-variant': '#6B7280',
          'on-background': '#1E293B',
          error: '#EF4444',
          warning: '#F59E0B',
          success: '#10B981',
          info: '#3B82F6',       
        },
      },
  

      
    },
  },
});


